import { restClient } from '../../client';
import { AppointmentRecurring } from '../../resources';


export type BookingIntent = {
  id: string;
  memberUuid: string;
  providerId: string;
  slotStart: string;
  slotEnd: string;
  slotAvailable: boolean | null;
  recurring: AppointmentRecurring;
  timezone: string;
  stateId: string;
  visitReasonIds: string[];
  payerName: string;
  insuranceCompanyId: string;
};


export const getBookingIntent = () =>
  restClient.request<{ data: BookingIntent }>('/api/v1/onboarding/booking_intent');
